"use client";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SpaceSm, SpaceMd, SizeBorderWidthThin, ColorGray200, ColorGray100 } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../Util/CostcoBox.js";
const AdSetContainer = styled(CostcoBox, {
  shouldForwardProp: (props) => props !== "bodyBackgroundColor" && props !== "ignoreBackground" && props !== "isFourCorners"
})(({ bodyBackgroundColor, ignoreBackground, isFourCorners, theme }) => {
  let styles = {
    display: "flex",
    flexDirection: "column",
    gap: SpaceMd,
    paddingBottom: SpaceMd,
    width: "100%",
    [theme.breakpoints.down("md")]: {
      '&[data-layout="large_ad"] > div > div': {
        flexBasis: "100%"
      },
      '&[data-layout="large_half_banner"] > div > div': {
        flexBasis: "100%"
      },
      '&[data-layout="one_fourth"] > div': {
        "> div": {
          flexBasis: `calc(50% - ${SpaceSm})`
        },
        flexWrap: "wrap",
        gap: SpaceSm
      },
      '&[data-layout="one_third"] > div, &[data-layout="half"] > div ,&[data-layout="full_1"] > div': {
        flexDirection: "column"
      }
    }
  };
  if (isFourCorners) {
    styles = {
      ...styles,
      minHeight: "100%",
      minWidth: "100%",
      ["@media (max-width:520px)"]: {
        width: `100%`
      },
      ["@media (max-width:1024px) and (min-width:520px)"]: {
        width: `calc((min(100vw, 1023px) / 2) - 44px)`
      },
      ["@media (min-width:1024px)"]: {
        width: `calc((min(100vw, 1400px) / 4) - 66px)`
      }
    };
  }
  if (!ignoreBackground) {
    styles = {
      ...styles,
      backgroundColor: bodyBackgroundColor ? bodyBackgroundColor : ColorGray100,
      border: `solid ${SizeBorderWidthThin} ${ColorGray200}`,
      borderRadius: "10px"
    };
  }
  return styles;
});
const HighlightCardGrid = styled(Box)(({ theme }) => {
  return {
    columnGap: 30,
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gridTemplateRows: "auto",
    rowGap: 32,
    width: "100%",
    [theme.breakpoints.down("lg")]: {
      gridTemplateColumns: "1fr 1fr"
    },
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "1fr"
    }
  };
});
export {
  AdSetContainer,
  HighlightCardGrid
};
